import { render } from "./AssetDetails.vue?vue&type=template&id=b4aab8b0&scoped=true&ts=true"
import script from "./AssetDetails.vue?vue&type=script&lang=ts"
export * from "./AssetDetails.vue?vue&type=script&lang=ts"

import "./AssetDetails.vue?vue&type=style&index=0&id=b4aab8b0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4aab8b0"]])

export default __exports__